<script lang="ts">
	import { viewport } from '../stores';
	import AdaptiveImage from './AdaptiveImage.svelte';
	import { t } from 'svelte-i18n';
	import Icon from '../elements/Icon.svelte';
	import OperationCategoryCircleIcon from '../../components/OperationCategoryCircleIcon.svelte';

	export let title: string | null = null;
	export let sector: string | null = null;
	export let mediaUrl: string | null = null;
	export let desc: string | null = null;
	export let isPrivateAccess = false;
	export let isPremiumOnly = false;
	export let isConfidential = false;
	export let href: string;
	export let isLoggedIn: boolean;
</script>

<a
	class="card relative flex flex-col border border-grey-light w-full rounded-lg mt-4 md:mt-5 bg-white no-underline hover:!no-underline link {!isConfidential
		? 'cursor-pointer'
		: ''}"
	{href}
	data-project-title={title ?? ''}
	data-connected={isLoggedIn}
	data-target="img"
>
	{#if sector}
		<div class="absolute z-1 top-0 left-1/2 transform -translate-y-1/2 -translate-x-1/2">
			<OperationCategoryCircleIcon category={sector} />
		</div>
	{/if}
	<div class="relative h-[238px] bg-grey-light rounded-t-lg overflow-hidden flex-shrink-0">
		{#if isPrivateAccess || isPremiumOnly}
			<div
				class="flex items-center md:space-x-2 p-1 md:p-2 text-sm text-white {isPremiumOnly
					? 'bg-premium'
					: 'bg-warning'} absolute bottom-0 right-0"
			>
				<Icon name="lock" size="small" />
				{#if $viewport.isDesktop}
					<span>
						{isPremiumOnly
							? $t('operation.messages.premiumAccess')
							: $t('operation.messages.privateAccess')}
					</span>
				{/if}
			</div>
		{/if}
		{#if mediaUrl}
			<AdaptiveImage src={mediaUrl} alt={title} classNames="object-cover w-full h-full" />
		{/if}
	</div>
	<div class="flex flex-col flex-1 p-3 md:p-4 space-y-3">
		<div class="space-y-2">
			{#if $$slots.alreadyInvest}
				<slot name="alreadyInvest">already invest here</slot>
			{/if}
			{#if $$slots.status}
				<slot name="status">status here</slot>
			{/if}
			<div data-project-title={title ?? ''} data-connected={isLoggedIn} data-target="title">
				<div class="font-display font-semibold text-2xl truncate cursor-pointer">
					{title}
				</div>
			</div>
			{#if $$slots.progress}
				<slot name="progress">CollectProgressIndicator here</slot>
			{/if}
		</div>

		{#if $$slots.body}
			<div class="space-y-3 flex-1">
				<slot name="body" />
				{#if desc}
					<p class="cursor-pointer">{desc}</p>
				{/if}
			</div>
		{/if}
		{#if $$slots.footer}
			<slot name="footer" />
		{/if}
	</div>
</a>
